"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _StyledTextFieldModule = _interopRequireDefault(require("./StyledTextField.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const StyledTextField = _ref => {
  let {
    label,
    handleChange,
    value,
    InputProps,
    ...restProps
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({
    label: label,
    className: `${_StyledTextFieldModule.default.styledTextField} ${_StyledTextFieldModule.default.className}`,
    value: value,
    onChange: handleChange,
    margin: "normal",
    variant: "outlined",
    slotProps: {
      input: InputProps
    }
  }, restProps));
};
var _default = exports.default = StyledTextField;